import { useCallback } from 'react';
import { useCommands } from '@remirror/react';

export const useImageHandler = () => {
  const commands = useCommands();

  return useCallback((e: React.ChangeEvent<HTMLInputElement>) => {
    const { files } = e.currentTarget;

    if (!files) return;

    const file = files[0];

    const isVideo = file.type.startsWith('video/') || /\.(mp4|webm|mov|avi|m4v)$/i.test(file.name);

    commands.uploadImage(async () => {
      const result = await uploadFile(file);

      return {
        ...result,
        'data-video': isVideo ? 'true' : 'false',
        'data-mime-type': file.type,
      };
    });
  }, [
    commands,
  ]);
};

function uploadFile(file: File) {
  const reader = new FileReader();

  return new Promise<{ src: string }>((resolve, reject) => {
    reader.onload = () => resolve({ src: reader.result as string });
    reader.onerror = () => reject(reader.error);
    setTimeout(() => reader.readAsDataURL(file), 1500);
  });
}